export default "__VITE_ASSET__DkHyv2Ti__"